<template>
<div>
    <h5 class="cabecera">Comentarios</h5>
    <div class="linea">
    </div>
    <div class="comment-container" style="">
      <div class="add-comment">
        <md-field>
          <label>Añade un comentario</label>
          <md-textarea v-model="issue.comentario"></md-textarea>
        </md-field>
        <md-button class="md-primary" @click="addComment" md-direction="top">Guardar</md-button>
      </div>
    </div>
</div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { SectionPanel } from "@/components";
import { reclamacionService } from "@/_services";

export default {
  name: "issue-comments",
  components: { SectionPanel },
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    addComment() {
      reclamacionService.addComment(this.issue, this.issue.comentario).then(
        (reclamacion) => {
          this.notify("Se ha guardado el comentario", "success");
          if(this.issue.category=='CLIENTE')
          {
            this.$router.push("/");
          }
          else{
            this.$emit("close", true);
          }  
        },
        (error) => {
          swal({
            title: "¡Se ha producido un error!",
            type: "error",
            text: error,
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false,
          });
        }
      );
    },
    notify(text, type) {
      this.$notify({
        message: text,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-comment {
  width: 100%;
}
.linea{
  border-bottom: #e0f3e7 solid 1px;
  width:100%;padding-bottom: 0px;
  margin-top: -15px;
}
.cabecera{
  padding-bottom: 0%;
  padding-left: 10px;
  padding-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color:#2a6917;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  width: 190px;
  background-color: #e0f3e7;
}
.comment-container {
  display: flex;
  padding: 10px;
}
</style>


